import clsx from "clsx"
import { ReactNode } from "react"
import { formatDistanceM } from "@/utils/formatDistance"
import { distanceMeters } from "@/utils/geo"
import { NormalizedGeoPoint } from "./geoPointHelpers"

type Props = {
  points: NormalizedGeoPoint[]
  gps: { lat: number; lng: number } | null
  highlightId?: string | null
  renderActions: (ctx: {
    point: NormalizedGeoPoint
    distanceM: number
    inRange: boolean
  }) => ReactNode
}

export default function GeoPointsList({
  points,
  gps,
  highlightId,
  renderActions,
}: Props) {
  const sorted = [...points].sort((a, b) => {
    if (!gps) return a.title.localeCompare(b.title, "ru")
    return (
      distanceMeters(gps.lat, gps.lng, a.lat, a.lng) -
      distanceMeters(gps.lat, gps.lng, b.lat, b.lng)
    )
  })

  return (
    <ul className="space-y-2">
      {sorted.map((point) => {
        const distanceM = gps
          ? distanceMeters(gps.lat, gps.lng, point.lat, point.lng)
          : Number.NaN
        const inRange =
          gps != null && distanceM <= point.radiusM && point.isAvailable !== false
        return (
          <li
            key={point.id}
            className={clsx(
              "rounded-xl border p-3",
              point.id === highlightId
                ? "border-guardians-accent/50 bg-guardians-accent/5"
                : "border-white/10 bg-white/5"
            )}
          >
            <div className="flex items-start justify-between gap-2">
              <div className="min-w-0">
                <p className="truncate text-sm font-medium">{point.title}</p>
                <p className="text-xs text-guardians-muted">
                  {gps ? formatDistanceM(distanceM) : "GPS…"}
                  {point.isAvailable === false ? " · недоступно" : inRange ? " · в радиусе" : ""}
                </p>
                {point.meta ? (
                  <p className="mt-0.5 text-[10px] text-guardians-muted">{point.meta}</p>
                ) : null}
              </div>
              {renderActions({ point, distanceM, inRange })}
            </div>
          </li>
        )
      })}
    </ul>
  )
}
